module.exports = __webpack_public_path__ + "img/bg-login-page-dark.fc0c8410.svg";